export default __webpack_public_path__ + "static/media/digna-tutorial-3.3df609c1.gif";